<template>
    <div class="vsm-item" :class="[{'open-item' : show}, {'active-item' : active}, {'parent-active-item' : childActive}]">
        <template v-if="!item.child">
            <template v-if="isRouterLink">
                

                <router-link v-if="!item.click" class="vsm-link" :to="item.href" :disabled="item.disabled">
                  <i v-if="item.icon" class="vsm-icon" :class="item.icon"></i>
                  <span class="vsm-title">{{item.title}}</span>
                </router-link>

                <a v-if="item.click" href="javascript:void(0)" class="vsm-link" @click="sendClick(item.click)">
                  <i v-if="item.icon" class="vsm-icon" :class="item.icon"></i>
                  <span class="vsm-title">{{item.title}}</span>
                </a>
            
            </template>
            <template v-else>
                <a class="vsm-link" :href="item.href" :disabled="item.disabled">
                    <i v-if="item.icon" class="vsm-icon" :class="item.icon"></i>
                    <span class="vsm-title">{{item.title}}</span>
                </a>
            </template>
        </template>
        <template v-else>
            <div class="vsm-link" @click="toggleDropdown">
                <i v-if="item.icon" class="vsm-icon" :class="item.icon"></i>
                <span class="vsm-title">{{item.title}}</span>
                <i class="vsm-arrow" :class="{'open-arrow' : show}"></i>
            </div>
            <div class="vsm-dropdown">
                <transition name="show-animation">
                    <div class="vsm-list" v-if="show">
                        <item v-for="(subItem, index) in item.child" :item="subItem" :key="index" />
                    </div>
                </transition>
            </div>
        </template>
    </div>
</template>

<script>
import Item from './Item.vue'
import { itemMixin } from './mixin'

export default {
  data() {
    return {
      show: false
    }
  },
  mixins: [itemMixin],
  props: {
    item: Object
  },
  methods: {
    sendClick(ref){

      if(ref == 'req-matricula'){
      
        window.eventBus.$emit('print', {url: '/api/pdf/renderRequerimentoMatricula', param: null});
      }
        
    },
  },
  components: {
    Item
  },
  beforeCreate() {
    this.$options.components.Item = require('./Item.vue').default
  }
}
</script>
